'use client';

import NotFoundPage from '@/components/error/not-found/not-found.component';
import { useEffect } from 'react';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        console.error(error);
    }, [error]);

    return <NotFoundPage error={error} />;
}
